import routerOptions0 from "/builds/common/airbaltic-com/company/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions0,
}